<template>
    <div class="container">
        <div class="row card">
            <div class="col-sm-10">
                <h2>Checkout Cancelled</h2>
                <!-- <hr /> -->
                <!-- <br /> -->
                <p>You cancelled the transaction. Subscription not complete.</p>
                <!-- <br /> -->
                <router-link to="/billing"
                    ><b-button variant="primary" class="mt-3">
                        Go back to billing
                    </b-button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Cancel',
}
</script>

<style scoped></style>
